import * as style from './ToastContainer.module.css';

export default function ToastWrapper({ children }: { children: React.ReactNode }) {
    return <div className={style.toastContainer}>{children}</div>;
}
